module.exports = __webpack_public_path__ + "static/media/time.b7d13ff4.png";